import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import style from './Document.style';
import { DocumentStatus, ScorecardStatus } from '@Constants/status';

// Analyze and building scorecard document
const DocumentSvg = ({ className, start, page, scorecardStatus, documentStatus, isIE11 }) => {
    const DOCUMENTSVG_ANIMATION_CLASSES = {
        paperLineOne: 'paper-line-1_animate',
        paperLineTwo: 'paper-line-2_animate',
        paperLineThree: 'paper-line-3_animate',
        paperLineFour: 'paper-line-4_animate',
        paperLineFive: 'paper-line-5_animate',
        paperLineSix: 'paper-line-6_animate',
        paperLineSeven: 'paper-line-7_animate',
        paperLineEight: 'paper-line-8_animate',
        docAnalysis: 'magnifying-glass-svg_doc-analysis',
        riskLevelBorders: 'paper-border_risk-level-borders',
        bounceInBottom: 'magnifying-glass-svg_bounce-in-bottom',
        slideOutBottom: 'magnifying-glass-svg_slide-out-bottom'
    };

    const [paperLineOne, setPaperLineOne] = useState('');
    const [paperLineTwo, setPaperLineTwo] = useState('');
    const [paperLineThree, setPaperLineThree] = useState('');
    const [paperLineFour, setPaperLineFour] = useState('');
    const [paperLineFive, setPaperLineFive] = useState('');
    const [paperLineSix, setPaperLineSix] = useState('');
    const [paperLineSeven, setPaperLineSeven] = useState('');
    const [paperLineEight, setPaperLineEight] = useState('');
    const [docAnalysis, setDocAnalysis] = useState('');
    const [bounceInBottom, setBounceInBottom] = useState('');
    const [slideOutBottom, setSlideOutBottom] = useState('');
    const [riskLevelBorders, setRiskLevelBorders] = useState('');

    useEffect(
        () => {
            if (start) {
                setBounceInBottom(DOCUMENTSVG_ANIMATION_CLASSES.bounceInBottom);

                if (!isIE11) {
                    if (documentStatus === DocumentStatus.PENDING) {
                        setDocAnalysis(DOCUMENTSVG_ANIMATION_CLASSES.docAnalysis);
                    }
                } else {
                    setDocAnalysis(DOCUMENTSVG_ANIMATION_CLASSES.docAnalysis);
                }
                if (documentStatus === DocumentStatus.PROCESSED) {
                    setSlideOutBottom(DOCUMENTSVG_ANIMATION_CLASSES.slideOutBottom);
                }
            }
        },
        [start, documentStatus]
    );

    useEffect(
        () => {
            if (start && page === 'scorecard') {
                if (scorecardStatus === ScorecardStatus.PENDING) {
                    setTimeout(() => {
                        setSlideOutBottom(DOCUMENTSVG_ANIMATION_CLASSES.slideOutBottom);
                        setRiskLevelBorders(DOCUMENTSVG_ANIMATION_CLASSES.riskLevelBorders);
                    }, 0);
                }
                if (scorecardStatus === ScorecardStatus.PROCESSED) {
                    setPaperLineOne(DOCUMENTSVG_ANIMATION_CLASSES.paperLineOne);
                    setPaperLineTwo(DOCUMENTSVG_ANIMATION_CLASSES.paperLineTwo);
                    setPaperLineThree(DOCUMENTSVG_ANIMATION_CLASSES.paperLineThree);
                    setPaperLineFour(DOCUMENTSVG_ANIMATION_CLASSES.paperLineFour);
                    setPaperLineFive(DOCUMENTSVG_ANIMATION_CLASSES.paperLineFive);
                    setPaperLineSix(DOCUMENTSVG_ANIMATION_CLASSES.paperLineSix);
                    setPaperLineSeven(DOCUMENTSVG_ANIMATION_CLASSES.paperLineSeven);
                    setPaperLineEight(DOCUMENTSVG_ANIMATION_CLASSES.paperLineEight);
                }

                setRiskLevelBorders('');
            }
        },
        [start, scorecardStatus]
    );

    if (!start || documentStatus === DocumentStatus.NOT_SUBMITTED) {
        return null;
    }

    return (
        <div className={`${className}`}>
            <svg
                id="magnifying-glass-id"
                className={`magnifying-glass-svg ${bounceInBottom} ${docAnalysis} ${slideOutBottom}`}
                viewBox="0 0 80 68"
            >
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g
                        transform="translate(40.000000, 40.000000) rotate(-45.000000) translate(-40.000000, -40.000000) translate(15.000000, -6.000000)"
                        fillRule="nonzero"
                    >
                        <g transform="translate(25.000000, 44.642857)">
                            <path
                                d="M1.99378882,17.2052984 L4.8757764,43.5474037 C5.0621118,45.2591178 6.61490683,46.4743043 8.33540373,46.2652399 L11,45.9451102 C12.7267081,45.7360458 13.9689441,44.1811299 13.7826087,42.4694157 L10.9006211,16.1273105 L1.99378882,17.2052984 Z"
                                fill="#3C3B35"
                            />
                            <path
                                d="M9.44099379,2.74066024 L10.9068323,16.1273105 L1.99378882,17.2052984 L0.527950311,3.81864818 C0.341614907,2.11346726 1.59006211,0.552018066 3.31677019,0.342953739 L5.98136646,0.0228239871 C7.70807453,-0.18624034 9.25465839,1.03547932 9.44099379,2.74066024 Z"
                                fill="#796F64"
                            />
                        </g>
                        <g>
                            <circle
                                fillOpacity="0.3"
                                fill="#0593B6"
                                opacity="0.5"
                                cx="25.1282051"
                                cy="25.0961538"
                                r="19.974359"
                            />
                            <path
                                d="M25.1282051,0.506410256 C11.5512821,0.506410256 0.544871795,11.5128205 0.544871795,25.0897436 C0.544871795,38.6666667 11.5512821,49.6730769 25.1282051,49.6730769 C38.7051282,49.6730769 49.7115385,38.6666667 49.7115385,25.0897436 C49.7115385,11.5128205 38.7051282,0.506410256 25.1282051,0.506410256 Z M25.1282051,45.0705128 C14.0961538,45.0705128 5.15384615,36.1282051 5.15384615,25.0961538 C5.15384615,14.0641026 14.0961538,5.12179487 25.1282051,5.12179487 C36.1602564,5.12179487 45.1025641,14.0641026 45.1025641,25.0961538 C45.1025641,36.1217949 36.1602564,45.0705128 25.1282051,45.0705128 Z"
                                fill="#796F64"
                            />
                        </g>
                    </g>
                </g>
            </svg>
            <div id="paper-id" className={`paper ${riskLevelBorders}`}>
                <svg className="paper-svg" viewBox="0 0 128 180">
                    <g
                        transform="translate(18.181818, 21.818182)"
                        fill="#efefef"
                        className="doc-lines-wrap"
                    >
                        <g>
                            <rect
                                id="paper-line-1-id"
                                className={`paper-line-1 ${paperLineOne}`}
                                x="0"
                                y="0"
                            />
                        </g>
                        <g transform="translate(0.000000, 11.666667)">
                            <rect
                                id="paper-line-2-id"
                                className={`paper-line-2 ${paperLineTwo}`}
                                x="0"
                                y="0"
                            />
                        </g>
                        <g transform="translate(0.000000, 23.333333)">
                            <rect
                                id="paper-line-3-id"
                                className={`paper-line-3 ${paperLineThree}`}
                                x="0"
                                y="0"
                            />
                        </g>
                        <g transform="translate(0.000000, 35.000000)">
                            <rect
                                id="paper-line-4-id"
                                className={`paper-line-4 ${paperLineFour}`}
                                x="0"
                                y="0"
                            />
                        </g>
                        <g transform="translate(0.000000, 46.666667)">
                            <rect
                                id="paper-line-5-id"
                                className={`paper-line-5 ${paperLineFive}`}
                                x="0"
                                y="0"
                            />
                        </g>
                        <g transform="translate(0.000000, 58.333333)">
                            <rect
                                id="paper-line-6-id"
                                className={`paper-line-6 ${paperLineSix}`}
                                x="0"
                                y="0"
                            />
                        </g>
                        <g transform="translate(0.000000, 70.000000)">
                            <rect
                                id="paper-line-7-id"
                                className={`paper-line-7 ${paperLineSeven}`}
                                x="0"
                                y="0"
                            />
                        </g>
                        <g transform="translate(0.000000, 81.666667)">
                            <rect
                                id="paper-line-8-id"
                                className={`paper-line-8 ${paperLineEight}`}
                                x="0"
                                y="0"
                            />
                        </g>
                    </g>
                </svg>
            </div>
            <div className="paper-shadow" />
        </div>
    );
};

export const Document = styled(DocumentSvg)`
    ${style};
`;
